<template>
    <div class="home">
        <Editor v-if="editingAllowed"></Editor>
        <PageHeader />

        <BannerNotice />
        <Banner />
        <Bar class="hidden-xs" />
        <SectionAbout />
        <SectionPanels />
        <SectionTabs />
        <div style="padding: 0 16px">
            <a
                id="mobile-home-business-brochure"
                href="https://docs.desjardins.com/dan/business-insurance/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    src="@/assets/img/business-brochure-350x170.jpg"
                    alt="Desjardins business insurance – Insuring your business just got easier"
                    class="mobile-home-business-brochure-image"
                    width="350"
                    height="170"
                />
            </a>
        </div>
    </div>
</template>

<script>
import PageHeader from '@/components/Layout/PageHeader.vue';
import Banner from '@/components/Layout/Banner.vue';
import BannerNotice from '@/components/Layout/BannerNotice.vue';
import Bar from '@/components/Layout/Bar.vue';
import SectionAbout from '@/components/SectionAbout.vue';
import SectionPanels from '@/components/SectionPanels.vue';
import SectionTabs from '@/components/SectionTabs.vue';
const Editor = () => import(/* webpackChunkName: "editor" */ '@/components/Editor/EditorBase.vue');

export default {
    name: 'Home',
    components: {
        PageHeader,
        Banner,
        BannerNotice,
        Bar,
        SectionAbout,
        SectionPanels,
        SectionTabs,
        Editor,
    },
};
</script>
<style lang="scss" scoped>
.mobile-home-business-brochure-image {
    display: block;
    width: 100%;
    max-width: 600px;
    border-radius: 16px;
    margin: 16px auto 36px auto;

    @include media('>=md') {
        display: none;
    }
}
</style>
